import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@exchange/environment'

@Injectable({
  providedIn: 'root'
})
export class RemittanceService {
  constructor(private http: HttpClient) {}

  deleteRemittance(deleteremittanceDto: RemittanceDeleteDto): Observable<object> {
    const url = `${environment.rmapiroot}/UpdateRemittance/DeleteRemittance`
    return this.http.post(url, deleteremittanceDto)
  }
}

export class RemittanceDeleteDto {
  RemittanceId: number
  Reason: string
}
